
angular.module('cvsApp').service('accountBalanceService',['networkService', 'xdrService', 'accountBalanceModel', 'configManager', 'cvsAppData', function (NS, XS, AM, CM, CAD) {
    
    function accBalService (){  
        this.getAccBal = function(callBackSuccess,tokenId){
            //get url
            var tid, tokenType;
            try{
                tid = CAD.getTokenId() ? CAD.getTokenId() : (tokenId || cvsUtility.queryMap.tokenId);
                tokenType = CAD.getTokenType() ? CAD.getTokenType() : ((tokenId) ? 'Guest' : 'Login');
            }
            catch(ex){
                tid = tokenId || cvsUtility.queryMap.tokenId;
                tokenType = (tokenId) ? 'Guest' : 'Login';
            }
            var url = CM.getAPIGEEAPIUrl('GET_ACCOUNT_BAL');
            if(url === "URL_ERROR"){
            }else{
                var request = {url:url,
                            header:{
                                'Content-Type': 'application/json',
                                'Accept': 'application/json',
                                'x-api-key': cvsUtility.queryMap.env == 'prod' ? 'dKfQbjnKcRxAVh4dO0oGbCCqBNxicnlw' : 'oYoT7FeCk2ht5D9rZn7un1TeKyaO8tX4'
                            },
                            timeout:getTimeout("getSpecialtyWCMContent"),
                            onSuccess:callBackSuccess
                        }
                if (cvsUtility.getIEVersion() <= 9) {
                    XS.makeRequest(url, xdrSuccess);
                    function xdrSuccess (data) {
                        AM.setResponse(data);
                        callBackSuccess(AM.getResponse());
                    }
                }
                else {
                    var balPromise = NS.get(request);   
                    balPromise.then(function(data, c, d){
                        console.log("data for success", data)
                        AM.setResponse(data.data);
                        callBackSuccess(AM.getResponse());
                        //send message to parent                    
                        //cvsUtility.sendPostMessage("SESSION-ALIVE","retrieveAccountBalance");
                        
                    }, function(reason){
                        callBackSuccess(NS.httpError(reason));
                    });                 
                }       
            }
                            
        }
        var getRequestBody = function(tokenId){
                var date = new Date();          
                var currentYear = date.getFullYear();
                var currentMonth =convertToTwoDigit(date.getMonth() + 1);
                var currentDay = convertToTwoDigit(date.getDate());
                
                var hour = convertToTwoDigit(date.getHours());
                var minute = convertToTwoDigit(date.getMinutes());
                var second = convertToTwoDigit(date.getSeconds());
                var timeStamp = currentYear + '-' + currentMonth + '-' + currentDay + 'T' + hour 
                    + ':' + minute + ':' + second;
            var tid, tokenType;
            try{
                tid = CAD.getTokenId() ? CAD.getTokenId() : (tokenId || cvsUtility.queryMap.tokenId);
                tokenType = CAD.getTokenType() ? CAD.getTokenType() : ((tokenId) ? 'Guest' : 'Login');
            }
            catch(ex){
                tid = tokenId || cvsUtility.queryMap.tokenId;
                tokenType = (tokenId) ? 'Guest' : 'Login';
            }
            var requestJson = {request:{
                                tokenID:tid,
                                tokenType:tokenType,
                                apiKey:cvsUtility.queryMap.apikey,
                                timestamp:timeStamp}}               
                
                return cvsUtility.JSONToXml(requestJson);
                function convertToTwoDigit (number) {
                    return (number < 10) ? '0' + number : number;
                }
            }           
    }
    
    return new accBalService(); 
}]);
